import { Box, Button, IconButton, styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import FallbackSpinner from "../../../materio/@core/components/spinner";
import { client } from "../../../utils/axios-client";
import CustomChip from 'src/materio/@core/components/mui/chip'
import { cloneDeep } from "lodash";
import { ApiResponseType } from "../../../types";
import ApplicationStore from "../../../stores/ApplicationStore";
import PageHeader from "../../../materio/@core/components/page-header";
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import EditIcon from '@mui/icons-material/Edit';
import EditCustomerDetails from "./EditCustomerDetails";
import AddIcon from '@mui/icons-material/Add'
import DeleteIcon from '@mui/icons-material/Delete';
import { useAuth } from "../../../hooks/useAuth";
import ConfirmationDialog from "../../common/ConfirmationDialog";
import { v4 as uuid } from 'uuid';
import EditPhoneNumber from "./EditPhoneNumber";
import RenderIf, { ClaimType, ClaimValue } from "../../common/RenderIf";
import { useParams } from "react-router-dom";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    padding: 2,
    verticalAlign: 'top'
}));

export type PhoneNumber = {
    id: string,
    isActive: boolean
    sid: string,
    friendlyName: string,
    number: string,
    location: string,
    countryId: string,
    ownerId: string,
    incomingCallAction: "FORWARD" | "VOICEMAIL" | "MANUAL ANSWER",
    forwardToNumber: string,
    voiceMessageURL: string,
    countryName: string,
    [key: string]: any
}

const PhoneNumberTable = () => {
    const [data, setData] = useState<PhoneNumber[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [editMode, setEditMode] = useState(false);
    const { user } = useAuth();
    const [selectedRecord, setSelectedRecord] = useState(null as null | PhoneNumber);
    const [editRecordOpen, setEditRecordOpen] = useState(false);
    let { userId } = useParams();

    //useEffect(() => {
    //    if (data) {
    //        setSelectedActivityType(data[0]);
    //        setOutcomeListOpen(true);
    //    }
    //}, [data])

    useEffect(() => {
        loadRecords()
    }, [])

    const loadRecords = async () => {
        //setIsLoading(true);
        const response = await client.get(`/api/admin/users/phone-numbers`, { params: { userId: userId } });
        setData(response.data);
        setIsLoading(false);
    }


    if (isLoading) return <FallbackSpinner />;

    if (!data) return <Box>Error fetching activity types</Box>;


    const onEdit = (row: PhoneNumber) => {
        setSelectedRecord(row);
        setEditRecordOpen(true);
    }

    const onAdd = () => {
        setSelectedRecord({
            id: uuid(),
            ownerId: userId,
            isActive: true
        } as PhoneNumber);

        setEditRecordOpen(true);
    }

    const onDelete = async (row: PhoneNumber) => {
        const result = confirm("Are you sure you want to delete these settings?");

        if (result) {
            const response = await client.delete<ApiResponseType>(`/api/admin/users/phone-numbers`, { params: { id: row.id } });

            if (response.data.succeeded) {
                ApplicationStore.update(s => {
                    s.snackbarMessage = "Settings Saved Successfully";
                    s.snackbarOpen = true;
                })

                loadRecords();
            } else {
                alert('error saving settings');
            }
        }


        ///setSelectedRecord(row);
        ///setEditRecordOpen(true);
    }

    const onCloseEditRecord = () => {
        loadRecords();
        setSelectedRecord(null);
        setEditRecordOpen(false);
    }

    const onUpdateInt = async (index: number, prop: string, value: string) => {
        const temp = cloneDeep(data);
        temp[index][prop] = parseInt(value);
        setData(temp);
    }

    const onUpdateString = async (index: number, prop: string, value: string) => {
        const temp = cloneDeep(data);
        temp[index][prop] = value;
        setData(temp);
    }

    const onUpdateBoolean = async (index: number, prop: string, value: boolean) => {
        const temp = cloneDeep(data);
        temp[index][prop] = value;
        setData(temp);
    }

    const onSaveDialog = async () => {
        const response = await client.post<ApiResponseType>('/api/activity-types', { items: data });
        if (response.data.succeeded) {
            loadRecords();

            ApplicationStore.update(s => {
                s.snackbarMessage = "Activity Types Saved Successfully";
                s.snackbarOpen = true;
            })
        } else {
            alert('error updating activity types');
        }
    }

    return <Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '40vh', maxHeight: '40vh', rowGap: 8 }}>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 4, alignItems: 'flex-end' }}>
                <RenderIf claimType={ClaimType.UserProfile} claimValue={ClaimValue.AddUserProfilePhoneNumber}>
                    <Button variant="contained" size="small" onClick={onAdd} endIcon={<AddIcon />}>Add</Button>
                </RenderIf>

            </Box>
            <TableContainer>
                <Table stickyHeader>
                    <TableHead>
                        <TableRow>
                            <StyledTableCell >Friendly Name</StyledTableCell>
                            <StyledTableCell>Number</StyledTableCell>
                            <StyledTableCell>Country</StyledTableCell>
                            <StyledTableCell sx={{ width: 100 }}></StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.map((item, index) => <TableRow>
                            <StyledTableCell>{item.friendlyName}</StyledTableCell>
                            <StyledTableCell >
                                {item.number}
                            </StyledTableCell>
                            <StyledTableCell>
                                {item.countryName}
                            </StyledTableCell>

                            <StyledTableCell title="Edit">
                                <RenderIf claimType={ClaimType.UserProfile} claimValue={ClaimValue.DeleteUserProfilePhoneNumber}>
                                    <IconButton size="small" onClick={() => onDelete(item)}><DeleteIcon /></IconButton>
                                </RenderIf>
                                <RenderIf claimType={ClaimType.UserProfile} claimValue={ClaimValue.EditUserProfilePhoneNumber}>
                                    <IconButton size="small" onClick={() => onEdit(item)}><EditIcon /></IconButton>
                                </RenderIf>

                            </StyledTableCell>
                        </TableRow>

                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
        {selectedRecord && <EditPhoneNumber open={editRecordOpen} onClose={onCloseEditRecord} record={selectedRecord} />}
    </Box>
}

export default PhoneNumberTable;